import { menuItems, type MenuItem } from 'hooks/utils/useMenu';

import { SearchRoute } from 'layout/search/SearchCommand';

/**
 * Derives search routes from the menu items.
 * This ensures the search command stays in sync with the sidebar navigation.
 */
function deriveSearchRoutesFromMenu(items: MenuItem[]): SearchRoute[] {
  const routes: SearchRoute[] = [];

  for (const item of items) {
    if ('children' in item && item.children) {
      // Parent with children - add each child as a route with parent as section
      for (const child of item.children) {
        routes.push({
          label: child.label,
          path: `/${child.path}`,
          section: item.label,
        });
      }
    } else if ('path' in item && item.path) {
      // Single item with path - add directly
      routes.push({
        label: item.label,
        path: `/${item.path}`,
      });
    }
  }

  return routes;
}

export const searchRoutes: SearchRoute[] =
  deriveSearchRoutesFromMenu(menuItems);
